import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChanges: {
        id: 'rv.policychange.wizard.step.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    locations: {
        id: 'rv.policychange.wizard.step.Locations',
        defaultMessage: 'Locations'
    },
    coverables: {
        id: 'rv.policychange.wizard.step.Coverables',
        defaultMessage: 'Coverables'
    },
    coverages: {
        id: 'rv.policychange.wizard.step.Coverages',
        defaultMessage: 'Coverages'
    },
    discounts: {
        id: 'rv.policychange.wizard.step.Discounts and Surcharges',
        defaultMessage: 'Discounts and Surcharges'
    },
    quote: {
        id: 'rv.policychange.wizard.step.Quote',
        defaultMessage: 'Quote'
    },
    payments: {
        id: 'rv.policychange.wizard.step.Payments',
        defaultMessage: 'Payments'
    },
    anErrorOccurred: {
        id: 'rv.policychange.wizard.error',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    anErrorOccurredTitle: {
        id: 'rv.policychange.wizard.error title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'rv.policychange.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'rv.policychange.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    }
});
